import apiClient from 'services/axios'

// da deprecare
export const getUrl = url =>
  url.indexOf('http') === 0 ? url : `${process.env.REACT_APP_PER1_URL}/${url.replace(/^\//g, '')}`

export const getUrlProd = url =>
  url.indexOf('http') === 0 ? url : `${process.env.REACT_APP_API_URL}/${url.replace(/^\//g, '')}`

export const getAutologinUrl = url => getUrl(`autologin-redirect?url=${encodeURIComponent(url)}`)

export const getPresignedUrl = async url => {
  const response = await apiClient.post('/users/generate-token?valid_once=true', { url })
  return `${getUrl(url)}?token=${response.data.access_token}`
}

export const autologin = () =>
  apiClient.post(
    getUrl('autologin'),
    {},
    {
      withCredentials: true,
    },
  )

export const resentCredentials = contactId =>
  apiClient.post(getUrl('api/contacts/resent-credentials'), { contatto_id: contactId })

/**
 * @param contactId
 * @param {"dataroom"|"talent"} accountType
 */
export const createAccount = (contactId, accountType) =>
  apiClient.post(getUrl('api/contacts/create-user'), {
    contatto_id: contactId,
    account_type: accountType,
  })

export const createTalentSearch = parms =>
  apiClient.post(getUrl('api/talent/searches/create'), parms)

export const getTalentSearches = contatto_id =>
  apiClient.get(getUrl(`api/talent/searches/list/${contatto_id}`))

export const deleteTalentSearches = parms =>
  apiClient.post(getUrl('api/talent/searches/delete'), parms)

export const deleteTalentSearch = parms => apiClient.post(getUrl('api/talent/search/delete'), parms)

export const deleteTalentComp = parms => apiClient.post(getUrl('api/talent/comp/remove'), parms)

export const subscribeTalent = parms =>
  apiClient.post(getUrl('api/talent/contatto/subscribe'), parms)

export const updateListTalent = parms =>
  apiClient.post(getUrl('api/talent/contatto/update-list'), parms)

export const updateTalentSearch = parms => apiClient.post(getUrl('api/talent/search/update'), parms)

export const getCustomerOffers = contactId =>
  apiClient.get(getUrl(`api/talent/customer-offers?id=${contactId}`))

export const talentCurriculumEnable = id =>
  apiClient.post(getUrl(`api/talent/curriculum-enable/${id}`))

export const talentCurriculumDisable = id =>
  apiClient.post(getUrl(`api/talent/curriculum-disable/${id}`))

export const getTalentProposte = cv => apiClient.get(getUrl(`api/talent/curriculum-proposte/${cv}`))

export const postTalentContattoToggle = data =>
  apiClient.post(getUrl(`api/talent/contatto/toggle`), data)

export const postTalentState = data => apiClient.post(getUrl(`api/talent/state`), data)
export const getContattiTalent = config => apiClient.get(getUrl(`api/talent/contatto-list`), config)

export const getItemCodes = params => apiClient.get(getUrl(`api/item_codes`), { params })
export const getItemCodesPageSettings = (params = {}) =>
  apiClient.get(getUrl(`api/item_codes/page-settings`), { params })
export const getItemCodesDescriptions = (params = {}) =>
  apiClient.get(getUrl(`api/item_codes/descriptions`), { params })

export const generaProjectReport = projectId =>
  apiClient.post(getUrl(`api/projects/report-pdf`), { id: projectId })

export const generaProjectReportExcel = projectId =>
  apiClient.post(getUrl(`api/projects/report-excel`), { id: projectId, dl: 0 })

export const getDocumentUrl = (nome_file, download = 0) =>
  apiClient.get(getUrl(`api/documents/preview-url`), { params: { nome_file, download } })

export const getDocument = id => apiClient.get(`api/documents/${id}`)

export const getChatMessages = config => apiClient.get(getUrl(`api/messages`), config)

export const postChatMessage = data => apiClient.post(getUrl(`api/messages`), data)

/**
 * @param search
 * @param {"1","2"} type
 */
export const getSkillsOptions = (search, type) =>
  apiClient
    .get(getUrl(`api/skills/autocomplete`), { params: { search, tipo: type, limit: 50 } })
    .then(r => r.data)

// project legacy

export const cloneProject = (projectId, options) =>
  apiClient.post(getUrl(`api/projects/clone`), { id: projectId, ...options }) // it/progetti/dupplica

export const cloneDocumentList = type =>
  apiClient.post(getUrl(`api/documents-template/list`), { tipo: type })

export const cloneGeneraDoc = (id, template_id) =>
  apiClient.post(getUrl(`api/progetti-utenti/genera-doc`), { ids: id, template_id })

export const signUrl = url => apiClient.post(getUrl(`api/sign-url`), { url })

// killerquestions legacy

export function getQuestions(annuncio_id) {
  return apiClient
    .get(getUrl('api/killer-questions/items'), { params: { annuncio_id } })
    .then(response => response.data)
}

export function saveQuestion(data) {
  return apiClient.post(getUrl('api/killer-questions/save'), data).then(response => response.data)
}

export function saveQuestionSort(data) {
  return apiClient.post(getUrl('api/killer-questions/sort'), data).then(response => response.data)
}

export function deleteQuestion(id) {
  return apiClient
    .post(getUrl('api/killer-questions/delete'), { id })
    .then(response => response.data)
}

export function getOptions(question_id) {
  return apiClient
    .get(getUrl('api/killer-questions/options'), { params: { question_id } })
    .then(response => response.data)
}

export function saveOptions(data) {
  return apiClient
    .post(getUrl('api/killer-questions/save-option'), data)
    .then(response => response.data)
}

export function saveOptionsSort(data) {
  return apiClient
    .post(getUrl('api/killer-questions/sort-option'), data)
    .then(response => response.data)
}

export function deleteOptions(id) {
  return apiClient
    .post(getUrl('api/killer-questions/delete-option'), { id })
    .then(response => response.data)
}

export function getJobChannels(params) {
  return apiClient.get(getUrl('api/job-ads/channels'), { params })
}

export function getExternalJobChannels(id) {
  return apiClient.get(getUrl('api/job-ads/external-channels'), { params: { id } })
}

export function channelPublish(params) {
  return apiClient.post(getUrl('api/job-ads/publish'), params)
}

export const rilOptions = type =>
  apiClient.get(getUrl(`/api/job-ads/ril-options?type=${type}`)).then(response => response.data)

export const cloneGeneraCv = (id, template_id) =>
  apiClient.post(getUrl(`api/documents/genera-cv`), { curriculum_id: id, template_id })

// settings email
export const cloneDeleteEmail = account_id =>
  apiClient.post(getUrl(`api/settings/email/remove-account`), { account_id })

export const importCvFile = data =>
  apiClient.post(getUrl(`api/documents/import-file`), data, {
    headers: { 'content-type': 'multipart/form-data' },
  })

export const importCvExcelFile = data =>
  apiClient.post(getUrl('api/candidates/import'), data, {
    headers: { 'content-type': 'multipart/form-data' },
  })

export const downloadFile = nomeFile => apiClient.get(getUrl(`api/file/download/${nomeFile}`))

// infinity
export const uploadInfinity = (curriculumId, selectedDocs) =>
  apiClient.post(getUrl(`api/infinity/upload`), {
    curriculum_id: curriculumId,
    documents: selectedDocs,
  })

// dynaset
export const uploadDynaset = (curriculumId, selectedDocs) =>
  apiClient.post(getUrl(`api/dynaset/upload`), {
    curriculum_id: curriculumId,
    documents: selectedDocs,
  })

// calendar
export const getCalendarEvents = ({
  start,
  end,
  mostra = '',
  users = [],
  withMe = undefined,
  withResources = undefined,
}) =>
  apiClient
    .get(getUrl(`api/per_events/calendar`), {
      params: {
        start,
        end,
        mostra,
        users,
        withMe,
        withResources,
      },
    })
    .then(r => r.data)

export const getExternalEvents = ({ start, end }) =>
  apiClient
    .get(getUrl(`api/per_events/external-items`), {
      params: {
        start,
        end,
      },
    })
    .then(r => r.data)

export function updateProfile(data) {
  return apiClient.post(getUrl('api/profile/update'), data).then(response => response.data)
}

export function updatePassword(data) {
  return apiClient.post(getUrl('api/profile/update-password'), data).then(response => response.data)
}

export const getSettingsCurrent = () => apiClient.get(getUrl(`api/settings/current`))

export const saveSettingsCurrent = data => apiClient.post(getUrl(`api/settings/save`), data)

export const getProfileCurrent = () => apiClient.get(getUrl(`api/profile/current`))

export const meetingsSend = id => apiClient.post(getUrl(`api/meetings/send`), { id })

export const dealsSend = id => apiClient.post(getUrl(`api/deals/send`), { id })

export const getSnipAd = () => apiClient.get(getUrl(`api/settings/snip-ad`))

export const reindexSkills = id => apiClient.post(getUrl(`api/skills/reindex`), { id })

export const getAccountInfo = () => apiClient.get(getUrl(`api/accounts/get-info`))

export const accountRemove = userId => apiClient.post(getUrl(`api/accounts/remove`), { userId })

export const getNotificationsCounter = () => apiClient.get(getUrl(`api/notifications/counter`))

export const getCapAutocomplete = cap =>
  apiClient.get(getUrl(`api/cap/autocomplete`), { params: { cap } })

export const getViesData = piva =>
  apiClient.post(`api/vies/service`, { params: { piva } })

export const getNotificationsList = () => apiClient.get(getUrl(`api/notifications/list`))

export const getUpdatesList = () => apiClient.get(getUrl(`api/updates/list`))

export const createPersonalAreaUser = curriculumId =>
  apiClient.post('api/curricula/personal-area/enable', { curriculumId })
export const activeAreaPersonal = () =>
  apiClient.post('api/curricula/personal-area/enable', {  })
export const deletePersonalArea = id =>
  apiClient.delete(`api/curricula/${id}/personal-area/delete`)

export const resetPersonalAreaUser = user_id =>
  apiClient.post(getUrl('api/area-nominativo/user/reset'), { user_id })

export const getCandidateAnalysis = (dal, al, stato) =>
  apiClient.get(getUrl(`api/candidate/analisi?dal=${dal}&al=${al}&stato=${stato}&type=charts`))

export const getProjectAnalysis = (dal, al, tipo_utente, utente) =>
  apiClient.get(
    getUrl(
      `api/project/analisi?dal=${dal}&al=${al}&tipo_utente=${tipo_utente}&utente_id=${utente}&type=charts`,
    ),
  )

export const getCandidatureAnalysis = (dal, al, user) =>
  apiClient.get(getUrl(`api/candidature/analisi?dal=${dal}&al=${al}&utente_id=${user}&type=charts`))

export const getGraphicsDashboard = () => apiClient.get(getUrl(`api/dashboard/counters`))

export const getCandidateChart = () => apiClient.get(getUrl(`api/candidate/chart`)) // Grafico de UpdatesCv del Dashboard

export const getChannelAnalysis = (dal, al) =>
  apiClient.get(getUrl(`api/annunci/analisis?dal=${dal}&al=${al}&type=charts`))
export const getCandidateSkill = () => apiClient.get(getUrl(`api/candidate/chart-competenze`)) // Dashboard skills

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getCandidatesDuplicates = ({nome, cognome, verifiedDuplicatesIds, id}) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const ids = [id, ...(verifiedDuplicatesIds || [])] // , ...verifiedDuplicatesIds
  return apiClient.get('/api/curricula/search', {
    params: { fullName: `${nome} ${cognome}`, fulltext: `NOT id:(${ids.join(' OR ')})`  }, //
  })
}

// AreaCandidate Doc Art. 53
// export const getUserdata = () => apiClient.get(getUrl(`api/doc53/getuserdata`))
export const getDocs53 = () => apiClient.get(getUrl(`api/doc53/get`))

export const getCurriculumExternal = (curriculumId) => apiClient.get(`/api/curricula_ext/${curriculumId}`)

export const AUTCOMPLETE_SKILLS_URL = getUrl('api/autocomplete-skills-object')

// Curriculum PATCH for rassegna normalization
export const getCurriculumById = (curriculumId) =>
  apiClient.get(`/api/curricula/${curriculumId}`)

export const patchCurriculumFields = (curriculumId, data) =>
  apiClient.patch(`/api/curricula/${curriculumId}`, data)

export default apiClient
